import { type QuantitativeSize } from './sizes';

export const Dimensions = ['height', 'width'] as const;
export type Dimension = (typeof Dimensions)[number];

export type Dimensions<T = QuantitativeSize> = {
  readonly height: T;
  readonly width: T;
};

/**
 * Represents a size specification that only allows sizing in 1 dimension but not the other.
 */
export type SingleDimension<T = QuantitativeSize> =
  | { height: T; width?: never }
  | { height?: never; width: T };
